import React from "react";
import Grid from "@mui/material/Grid";
import Image from "next/legacy/image";
import styles from "./mentor_connect.module.scss";
import { getAssets } from "@unisearch/helpers";

export const MentorConnect = () => {
  return (
    <section className={styles.section_mentor_connect}>
      <div className="container">
        <h2 className="center">Connect With Our Mentors</h2>
        <p className={styles.sub_title}>
          Sign up with us today to connect with our student mentors and find out
          everything you need to know about studying abroad, from the
          perspective of an international student.
        </p>

        <Grid container spacing={3} sx={{ marginTop: 2 }}>
          <Grid item xs={12} md={4}>
            <div className={styles.connect_card}>
              <Image
                width={300}
                height={250}
                blurDataURL={getAssets(
                  "/assets/images/image_placeholder_big.webp"
                )}
                placeholder="blur"
                src={getAssets("assets/images/mentor/signup-illustration.webp")}
                alt="Sign Up"
              />

              <h5 className={`${styles.card_title} center fw600 `}>Sign Up</h5>
              <p className={"font-small center"}>
                Create an account in seconds with Social Logins
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={styles.connect_card}>
              <Image
                width={300}
                height={250}
                blurDataURL={getAssets(
                  "/assets/images/image_placeholder_big.webp"
                )}
                placeholder="blur"
                src={getAssets(
                  "/assets/images/mentor/complete-profile-illustration.webp"
                )}
                alt="Sign Up"
              />

              <h5 className={`${styles.card_title} center fw600 `}>
                Complete Your Profile
              </h5>
              <p className={"font-small center"}>
                Fill out your basic information and study preferences
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={styles.connect_card}>
              <Image
                width={300}
                height={250}
                blurDataURL={getAssets(
                  "/assets/images/image_placeholder_big.webp"
                )}
                placeholder="blur"
                src={getAssets(
                  "/assets/images/mentor/connect-illustration.webp"
                )}
                alt="Sign Up"
              />
              <h5 className={`${styles.card_title} center fw600 `}>
                Connect with a Mentor
              </h5>
              <p className={"font-small center"}>
                Select from our student mentors from around the world and
                connect one-to-one for advice and guidance
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default MentorConnect;
